import React from "react";

interface Kxd3DEditorIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const Kxd3DEditorIcon: React.FC<Kxd3DEditorIconProps> = ({
  width = 20,
  height = 20,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Konnect 3D Editor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3333 0C18.7754 0 19.1992 0.175721 19.5117 0.488281C19.8243 0.800842 20 1.22464 20 1.66667V18.3333C20 18.7754 19.8243 19.1992 19.5117 19.5117C19.1992 19.8243 18.7754 20 18.3333 20H1.66667C1.22464 20 0.800842 19.8243 0.488281 19.5117C0.175721 19.1992 0 18.7754 0 18.3333V1.66667C0 1.22464 0.175721 0.800842 0.488281 0.488281C0.800842 0.175721 1.22464 0 1.66667 0H18.3333ZM4.49761 7.70616C4.48152 7.71487 4.46785 7.72699 4.45855 7.74197C4.44929 7.75702 4.4444 7.77455 4.44444 7.79188V12.105C4.44493 12.3127 4.50425 12.5164 4.61589 12.6964C4.7276 12.8765 4.88799 13.0269 5.08138 13.1315L9.41189 15.5425C9.42813 15.5512 9.4474 15.5556 9.46615 15.5556C9.48477 15.5555 9.50318 15.5512 9.51931 15.5425C9.53555 15.5338 9.54899 15.5207 9.55838 15.5056C9.56757 15.4908 9.5724 15.474 9.57248 15.4568V10.4536C9.57246 10.4362 9.56775 10.4187 9.55838 10.4036C9.54905 10.3887 9.53543 10.3765 9.51931 10.3678L4.60503 7.70616C4.58874 7.69743 4.56959 7.69203 4.55078 7.69206C4.53208 7.69214 4.51378 7.69743 4.49761 7.70616ZM15.395 7.70725L10.4807 10.3852C10.4646 10.3939 10.451 10.4061 10.4416 10.421C10.4323 10.436 10.4276 10.4536 10.4275 10.4709V15.4557C10.4276 15.4729 10.4324 15.4897 10.4416 15.5046C10.451 15.5196 10.4644 15.5328 10.4807 15.5415C10.4968 15.5501 10.5153 15.5544 10.5339 15.5545C10.5526 15.5545 10.5719 15.5502 10.5881 15.5415L14.9186 13.1293C15.1117 13.0249 15.2724 12.876 15.3841 12.6964C15.4958 12.5167 15.5548 12.3125 15.5556 12.105V7.79188C15.5554 7.77477 15.5506 7.75789 15.5415 7.74306C15.5321 7.72806 15.5186 7.71483 15.5024 7.70616C15.4862 7.6975 15.4669 7.69313 15.4481 7.69314C15.4296 7.69324 15.411 7.69863 15.395 7.70725ZM10 4.44444C9.69829 4.44444 9.40166 4.51881 9.14062 4.65929L5.06185 6.85981C5.04581 6.86854 5.03205 6.88065 5.02279 6.89562C5.01349 6.91065 5.00868 6.92819 5.00868 6.94553C5.00873 6.96263 5.01369 6.9795 5.02279 6.99436C5.03209 7.00939 5.04572 7.02251 5.06185 7.03125L9.94683 9.69835C9.96326 9.70734 9.98202 9.71246 10.0011 9.71246C10.0201 9.71241 10.039 9.70729 10.0553 9.69835L14.9382 7.03125C14.9543 7.02251 14.9679 7.00939 14.9772 6.99436C14.9864 6.97944 14.9913 6.96272 14.9913 6.94553C14.9913 6.92819 14.9865 6.91065 14.9772 6.89562C14.9679 6.8807 14.9542 6.8685 14.9382 6.85981L10.8594 4.65929C10.5984 4.51883 10.3017 4.44447 10 4.44444Z"
        fill="#002366"
      />
    </svg>
  );
};

export default Kxd3DEditorIcon;
